export const CTA_BLOCK_s5 =   {
  "blockType": "CTA",
  "blockDesign": "CTADesign1",
  "editFormName": "CTA_01_FORM",
  "styleProps": {
    "background-color": "#E5BCE6",
    "padding": "120px 20px 120px 20px",
    "background-image": "linear-gradient(to bottom,,)"
  },
  "headings": [
    {
      "text": "What's next?",
      "styleProps": {
        "text-align": "center",
        "font-size": "1.25rem",
        "line-height": "1.75rem",
        "padding": "10px 30px 10px 30px",
        "color": "#333333",
        "font-family-cust": "",
        "font-family": "'Open Sans', sans-serif",
        "font-family-bk": "'Open Sans', sans-serif",
        "font-weight": "900",
        "border-width": "1px",
        "border-color": "#12121211",
        "border-radius": "1rem"
      },
      "alignStyleProps": {
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "2.25rem",
        "line-height": "2.5rem"
      }
    },
    {
      "text": "The future is here. Start your business.",
      "styleProps": {
        "text-align": "center",
        "padding": "20px 0px 30px 0px",
        "color": "#333333",
        "font-size": "4.5rem",
        "line-height": "1",
        "font-family": "'Open Sans', sans-serif",
        "font-weight": "900"
      },
      "alignStyleProps": {
        "text-align": "center"
      },
      "stylePropsTab": {
        "font-size": "3rem",
        "line-height": "1"
      },
      "stylePropsMob": {
        "font-size": "1.875rem",
        "line-height": "2.25rem"
      }
    }
  ],
  "showBtnSec": true,
  "btnSecStyleProps": {
    "justify-content": "center",
    "padding": "40px 0px 0px 0px"
  },
  "btnSecStylePropsTab": {},
  "btnSecStylePropsMob": {},
  "buttons": [
    {
      "text": "GET STARTED  ➜",
      "alt": "Click Here",
      "href": "https://yahoo.com",
      "styleProps": {
        "background-color": "#0E0F10",
        "color": "#ffffff",
        "border-color": "#3b82f680",
        "border-radius": "1rem",
        "padding": "18px 40px 18px 40px",
        "border-width": "0px"
      },
      "openType": "sametab"
    },
    {
      "text": "Compare Plans",
      "styleProps": {
        "color": "#333333",
        "border-color": "#3b82f680",
        "background-color": "",
        "border-width": "0px",
        "border-radius": "1rem",
        "padding": "18px 40px 18px 40px"
      },
      "href": "",
      "openType": "sametab"
    }
  ],
  "showEmailSec": true,
  "emailSecStyleProps": {},
  "subscription": {
    "showSection": "hide",
    "display": "enable",
    "subConfigs": {
      "configType": "convertkit",
      "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
      "configPlaceholder": ""
    },
    "email_placeholder": {
      "text": "example@mail.com"
    },
    "buttonText": {
      "text": "Subscribe",
      "styleProps": {
        "background-color": "#1b1b31",
        "color": "#ffffff"
      }
    },
    "successMessage": {
      "text": "Thank you for the signup",
      "styleProps": {}
    },
    "errorMessage": {
      "text": "Something went wrong. Please try again.",
      "styleProps": {}
    }
  },
  "metaDataId": 1746190111921,
  "afterIndex": 10,
  "blockId": 1746190111921,
  "containerStyleProps": {
    "padding": "0px 0px 0px 0px",
    "max-width": "896px"
  },
  "containerStylePropsTab": {
    "padding": "0px 0px 0px 0px"
  },
  "fonts": {
    "headings": [
      ""
    ]
  },
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}